export const SYSTEM_ADMIN = { key: 'SYSTEM_ADMIN', name: 'Systemadministrator' };
export const ORGANISATION_OWNER = { key: 'ORGANISATION_OWNER', name: 'Veranstalter' };
